{
  "name": "@org-avp/naap-demo-iframe-app",
  "version": "1.8.0",
  "private": true,
  "scripts": {
    "lint": "biome check --write .",
    "copy-assets": "cp -r ./index.html ./compat.js ./dist/frontend",
    "build:css": "tailwindcss -i ./src/styles.css -o ./dist/frontend/styles.css --minify && node ./scripts/lower-css.mjs",
    "build:frontend": "esbuild ./src/frontend/index.ts ./src/frontend/sw.ts --bundle --tsconfig=tsconfig.frontend.json --platform=browser --target=chrome80 --sourcemap --outdir=./dist/frontend",
    "inject-sw": "node ./inject-sw.mjs",
    "build": "pnpm run build:css && pnpm run build:frontend && pnpm run copy-assets && pnpm run inject-sw && node ../../scripts/check-floor-css.mjs dist/frontend",
    "serve": "npx serve dist/frontend -p 4210",
    "synth:dist": "cdk synth *-dist-* --output cdk.out/dist --profile dist",
    "deploy:dist": "cdk deploy *-dist-* --method=direct --require-approval=never --output cdk.out/dist --profile dist",
    "destroy:dist": "cdk destroy *-dist-* --force --profile dist"
  },
  "dependencies": {
    "@opentelemetry/api": "^1.9.1",
    "@opentelemetry/context-zone": "^2.8.0",
    "@opentelemetry/core": "^2.8.0",
    "@opentelemetry/exporter-trace-otlp-http": "^0.219.0",
    "@opentelemetry/resources": "^2.8.0",
    "@opentelemetry/sdk-trace-base": "^2.8.0",
    "@opentelemetry/sdk-trace-web": "^2.8.0",
    "@org-avp/models": "^16.14.0",
    "@org-avp/naap-app-sdk": "workspace:2.5.0",
    "@org-avp/naap-models": "workspace:1.1.0",
    "aws-cdk-lib": "^2.267.0",
    "jose": "^6.2.12",
    "tailwindcss": "^4.3.3",
    "workbox-core": "^7.4.1",
    "workbox-precaching": "^7.4.1",
    "workbox-routing": "^7.4.1",
    "workbox-strategies": "^7.4.1",
    "workbox-window": "^7.4.1",
    "zod": "^4.6.5"
  },
  "devDependencies": {
    "@csstools/postcss-cascade-layers": "^6.0.0",
    "@tailwindcss/cli": "^4.3.0",
    "lightningcss": "1.33.0",
    "postcss": "^8.5.28",
    "workbox-build": "^7.4.1"
  }
}
